import { getHotComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotRecommendSection() {
  const hotComics = getHotComics(6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-3">
              热门推荐
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              大家都在看
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              精选全网最热韩国漫画，实时更新热度排行
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}